import admin from './admin';

const attendanceApi = {
  admin,
};

export default attendanceApi;
